module.exports = __webpack_public_path__ + "img/spaceapps-logo.fcaf71b3.png";